import { useGetPrivacyPolicy } from "../../services/queries"
import NCLoader from "../../shared/NCLoader"
import PrivacyLayout from "./PrivacyLayout"

const PrivacyPolicy = () => {
  const { isLoading, data } = useGetPrivacyPolicy()
  const pageContent = data?.data?.data?.results?.[0]?.body || null
  return (
    <PrivacyLayout title="">
      {pageContent ? (
        <div
          className="external-html"
          dangerouslySetInnerHTML={{ __html: pageContent }}
        />
      ) : null}
      <NCLoader open={isLoading} />
    </PrivacyLayout>
  )
}
export default PrivacyPolicy
